import React from "react";
import { graphql } from "gatsby";
import GraphQLErrorList from "../../components/graphql-error-list";
import Seo from "../../components/seo";
import Layout from "../../containers/layout-dark";

import PageHeader from "../../components/page-header";
import Plans from "../../components/plans";
import SolutionPricing from "../../components/solution-pricing";
import CallToAction from "../../components/call-to-action";

import * as styles from "../../styles/components/plans-page.module.css";

export const query = graphql`
  fragment SanityImage on SanityMainImage {
    crop {
      _key
      _type
      top
      bottom
      left
      right
    }
    hotspot {
      _key
      _type
      x
      y
      height
      width
    }
    asset {
      _id
    }
  }

  query PricingPageQuery {
    pricing: sanityPricing {
      pageHeader {
        title
        subtitle
        description
        button {
          text
          url
          blank
          secondaryButton
        }
        link {
          blank
          text
          url
        }
      }
      plans {
        _key
        title
        description
        price
        duration
        button {
          blank
          secondaryButton
          text
          url
        }
        features
        link {
          text
          url
        }
      }
      solutionPricing {
        heading
        _rawContent
        solutions {
          _key
          pageHeader {
            title
            description
          }
          category {
            title
            slug {
              current
            }
          }
          price
          transactions
          slug {
            current
          }
        }
      }
      callToAction {
        title
        button {
          blank
          secondaryButton
          text
          url
        }
        link {
          blank
          text
          url
        }
        image {
          ...SanityImage
          alt
        }
      }
      pageMetaInfo {
        metaTitle
        metaDescription
      }
    }
  }
`;

const PricingPage = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const pricing = (data || {}).pricing;

  return (
    <Layout>
      <Seo
        title={pricing.pageMetaInfo?.metaTitle || pricing.pageHeader.title}
        description={pricing.pageMetaInfo?.metaDescription || pricing.pageHeader.description}
      />

      {pricing.pageHeader && <PageHeader {...pricing.pageHeader} titleWidth="xxl" descWidth="md" pricingPage="true" dark="true" />}
      <div className={styles.root}>
        {(pricing.plans && pricing.plans.length) ? <Plans items={pricing.plans} /> : null}
      </div>
      {/* temp fix to remove solution section */}
      {false && pricing.solutionPricing && <SolutionPricing {...pricing.solutionPricing} />}
      {pricing.callToAction && <CallToAction {...pricing.callToAction} />}
    </Layout>
  );
};

export default PricingPage;
